import React from 'react';
import { observer } from 'mobx-react'

import {
  Wrapper,
  Container,
  LogoWrapper,
  Title,
} from './style';

import LystLogo from '../LystLogo';

import IntroCloudState from '../../states/IntroCloudState';

const IntroTitle = ({ active }) => (
  <Wrapper active={active}>
    <Container
      style={{
        height: IntroCloudState.containerHeight * 4,
        width: IntroCloudState.containerWidth * 4,
      }}
    >
      <LogoWrapper>
        <LystLogo scale={4} />
      </LogoWrapper>
      <Title>
        <span>The Year</span>
        <span>in Fashion</span>
        <span>2017</span>
      </Title>
    </Container>
  </Wrapper>
);

export default observer(IntroTitle);



// WEBPACK FOOTER //
// ./src/components/IntroTitle/index.js